import React from 'react'
import './Footer.scss'

import logoParadigma from '../../images/logoParadigma.png'
import iconInstagram from '../../images/instagram.png'
import iconWhatsapp from '../../images/whatsapp.png'


const Footer = () => {
	return (
		<footer>
			<div className="container">
				<div className="row">
					<div className="col-md-4">
						<p>
							<a href="https://maps.app.goo.gl/jHsq3kpbxtjoYTJY8" target="_blank" rel="noreferrer">
								Villarino e Italia, Bahía Blanca
							</a> <br />
							Tel. 0291 4547010 <br />
							{/* Tel. ‎+54 9 291 576-3137 <br /> */}
							<img src={iconWhatsapp} alt="" className="icon"/>
							<a href="https://api.whatsapp.com/send?phone=5492914497131" target="_blank" rel="noreferrer">+54 9 2914 49-7131</a>
						</p>
					</div>
					<div className="col-md-4">
						<p>
							info@autopartesdelsur.com.ar <br />
							pedidos@autopartesdelsur.com.ar <br />
							<img src={iconInstagram} alt="" className="icon"/>
							<a href="https://instagram.com/autopartesdelsur_" target="_blank" rel="noreferrer">@autopartesdelsur_</a>
						</p>
					</div>
					<div className="col-md-4">
						<p>
							©{new Date().getFullYear()} Diseño y Desarrollo:<br />
							<img src={logoParadigma} alt="Paradigma del Sur s.a." />
						</p>
					</div>
				</div>
			</div>
		</footer>
	)
}

export default Footer
